<template>
  <div class="col hidden c-lg:block">
    <ul class="row c-justify-start c-pl-3 no-gutters list-unstyled c-m-0">
      <li
        class="col-auto new-product-link"
      >
        <router-link
          :to="dynamicProductPath('ready_new_products')"
          class="btn btn-outline-primary c-xl:c-py-3 c-xxl:c-py-2 border-0 c-rounded-pill"
        >
          <StarsSvg
            class="ml-n2 c-mr-2 my-n2"
            width="30"
            height="30"
          />
          {{ t('new_products') }}
        </router-link>
      </li>
      <li
        v-if="false"
        class="col-auto birthday-link"
      >
        <router-link
          :to="dynamicProductPath('ready_easter')"
          class="btn btn-outline-primary c-xl:c-py-3 c-xxl:c-py-2 border-0 c-rounded-pill"
        >
          <EasterSvg
            class="c-mr-0 my-n2"
            width="30"
            height="30"
          />
          {{ t('easter') }}
        </router-link>
      </li>
      <li class="col-auto">
        <VDropdown theme="navbarMainMenu">
          <button
            class="btn btn-outline-primary c-xl:c-py-3 c-xxl:c-py-2 border-0 c-rounded-pill"
            type="button"
          >
            {{ t('eshop') }}
          </button>
          <template #popper>
            <TheNavbarMainMenuPopover />
          </template>
        </VDropdown>
      </li>
      <li
        v-if="isSignedIn"
        class="col-auto"
      >
        <router-link
          :to="{ name: 'customerCreditsPath' }"
          class="btn btn-outline-primary c-xl:c-py-3 c-xxl:c-py-2 border-0 c-rounded-pill"
          :class="{'credits-link' : country === 'de' || country === 'at' || country === 'cs'}"
        >
          {{ t('my_credits') }}
          <span
            v-if="creditsSum >= 1"
            class="inline-block c-py-1 c-px-2 mt-n2 mr-n1 absolute top-0 right-0 bg-danger c-rounded-pill whitespace-nowrap text-sm-c text-white c-leading-1"
          >
            <span class="text-sm-c text-white c-leading-1"> {{ Math.floor(creditsSum) }} {{ t('currency') }}</span>
          </span>
        </router-link>
      </li>
      <li
        v-else
        class="col-auto"
      >
        <router-link
          :to="{ name: 'signUpPath' }"
          class="btn btn-outline-primary c-xl:c-py-3 c-xxl:c-py-2 border-0 c-rounded-pill"
          :class="{'credits-link' : country === 'fr'}"
        >
          {{ t('collect_credits') }}
        </router-link>
      </li>
      <li
        v-if="false"
        class="col-auto hidden c-xl:block"
      >
        <router-link
          :to="{ name: 'aboutUsPath' }"
          class="btn btn-outline-primary c-xl:c-py-3 c-xxl:c-py-2 border-0 c-rounded-pill"
        >
          {{ t('about_us') }}
        </router-link>
      </li>
      <li
        v-if="false"
        class="col-auto hidden c-xl:block"
      >
        <router-link
          :to="{ name: 'faqPath' }"
          class="btn btn-outline-primary c-xl:c-py-3 c-xxl:c-py-2 border-0 c-rounded-pill"
        >
          {{ t('questions') }}
        </router-link>
      </li>
      <li class="col-auto hidden c-lg:block">
        <VDropdown theme="usermenu">
          <button
            class="btn btn-outline-primary border-0 c-rounded-pill text-lg-c c-xxl:c-py-1 c-xl:c-py-2 c-py-1 font-bold"
            type="button"
          >
            ···
          </button>
          <template #popper>
            <TheNavbarMenuPopover :credits-sum="creditsSum" />
          </template>
        </VDropdown>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import ApiServiceV1 from '@/api/adminApi/AdminApiV1'
import StarsSvg from '@/components/svg/navbarMenu/StarsSvg.vue'
import EasterSvg from "@/components/svg/navbarMenu/EasterSvg.vue";
import { useCategoriesStore } from '@/stores/CategoriesStore'
import { useAppStore } from '@/stores/AppStore'
import { useCountry } from '@/mixins/useCountry'

import TheNavbarMainMenuPopover from './TheNavbarMainMenuPopover.vue'
import TheNavbarMenuPopover from './TheNavbarMenuPopover.vue'

const { t, locale } = useI18n()
const country = useCountry()

const appStore = useAppStore()
const { isSignedIn } = storeToRefs(appStore)
const { dynamicProductPath } = useCategoriesStore()

const creditsSum = ref(0)

const loadCredits = async () => {
  if (isSignedIn.value) {
    const { data } = await ApiServiceV1.get('customer/customer_credits')
    creditsSum.value = data.creditsSum
  }
}

loadCredits()
</script>

<style lang="scss" scoped>
.new-product-link {
  .btn-outline-primary {
    background-color: #bf1818;
    color: #EDD2A5;
    border-radius: 50rem;

    &:hover {
      background-color: #8d1313;
    }
  }
}
.credits-link {
  display: block;
  @media screen and (max-width: 1420px) {
    display: none;
  }
}
</style>

<i18n>
  {
    "cs": {
    "about_us": "O nás",
    "birthday": "Narozeniny",
    "blog": "Blog",
    "christmas": "Vánoce",
    "collect_credits": "Sbírat kredity",
    "currency": "Kč",
    "easter": "Velikonoce",
    "eshop": "E-shop",
    "my_credits": "Moje kredity",
    "new_products": "Novinky",
    "questions": "Otázky",
    "valentine": "Valentýn"
},
    "sk": {
    "about_us": "O nás",
    "birthday": "Narodeniny",
    "blog": "Blog",
    "christmas": "Vianoce",
    "collect_credits": "Zbierať kredity",
    "currency": "€",
    "easter": "Veľká noc",
    "eshop": "E-shop",
    "my_credits": "Moje kredity",
    "new_products": "Novinky",
    "questions": "Otázky",
    "valentine": "Valentín"
},
    "pl": {
    "about_us": "O nas",
    "birthday": "Urodziny",
    "blog": "Blog",
    "christmas": "Boże Narodzenie",
    "collect_credits": "Zbieraj punkty",
    "currency": "zł",
    "easter": "Wielkanoc",
    "eshop": "E-shop",
    "my_credits": "Moje punkty",
    "new_products": "Nowości",
    "questions": "Pytania",
    "valentine": "Walentynki"
},
    "hu": {
    "about_us": "Rólunk",
    "birthday": "Szülinap",
    "blog": "Blog",
    "christmas": "Karácsony",
    "collect_credits": "Kreditek",
    "currency": "Ft",
    "easter": "Húsvét",
    "eshop": "Webshop",
    "my_credits": "Kreditek",
    "new_products": "Újdonságok",
    "questions": "Kérdések",
    "valentine": "Valentin"
},
    "de": {
    "about_us": "Über uns",
    "birthday": "Geburtstag",
    "blog": "Blog",
    "christmas": "Weihnachten",
    "collect_credits": "Punkte sammeln",
    "currency": "EUR",
    "easter": "Ostern",
    "eshop": "E-shop",
    "my_credits": "Meine Punkte",
    "new_products": "Neuheiten",
    "questions": "Fragen",
    "valentine": "Valentinstag"
},
    "at": {
    "about_us": "Über uns",
    "birthday": "Geburtstag",
    "blog": "Blog",
    "christmas": "Weihnachten",
    "collect_credits": "Punkte sammeln",
    "currency": "EUR",
    "easter": "Ostern",
    "eshop": "E-shop",
    "my_credits": "Meine Punkte",
    "new_products": "Neuheiten",
    "questions": "Fragen",
    "valentine": "Valentinstag"
},
    "ro": {
    "about_us": "Despre noi",
    "birthday": "Aniversare",
    "blog": "Blog",
    "christmas": "Crăciun",
    "collect_credits": "Adună credite",
    "currency": "Lei",
    "easter": "Paște",
    "eshop": "E-shop",
    "my_credits": "Creditele mele",
    "new_products": "Noutăți",
    "questions": "Întrebări",
    "valentine": "Ziua Îndrăgostiților"
},
    "fr": {
    "about_us": "À propos de nous",
    "birthday": "Anniversaire",
    "blog": "Blog",
    "christmas": "Noël",
    "collect_credits": "Gagner des crédits",
    "currency": "€",
    "easter": "Pâques",
    "eshop": "E-shop",
    "my_credits": "Mes crédits",
    "new_products": "Nouveautés",
    "questions": "Des questions",
    "valentine": "Saint-Valentin"
},
    "it": {
    "about_us": "Chi siamo",
    "birthday": "Compleanno",
    "blog": "Blog",
    "christmas": "Natale",
    "collect_credits": "Accumula crediti",
    "currency": "€",
    "easter": "Pasqua",
    "eshop": "E-shop",
    "my_credits": "I miei crediti",
    "new_products": "Novità",
    "questions": "Domande",
    "valentine": "San Valentino"
}
  }
</i18n>
